const $ = require("jquery");
const { Foundation, dataLayer } = window;
const FormController = require("../../utilities/_form-controller");
const _ = require("lodash");
const Stepper = require("../stepper/Stepper");
const kickboxCheck = require("../../src/run/kickbox/kickboxCheck");

class MultiSelectForm {
	constructor (id, utmCookies) {
		this.id = id;
		this.setupForm();
		this.stepper = new Stepper(this.getStepperId());
		utmCookies.initForm(this.getForm()[0]);
	}

	setupForm () {
		new Foundation.Abide(this.getForm());

		this.getForm()
			.on("formvalid.zf.abide", () => this.submit())
			.on("submit", e => e.preventDefault());

		this.getCountryField().on('change', e => {
			const country = e.target.value;
			if (country !== "United States") {
				this.getPrivacyPolicyAgreementMessageContainer().removeClass('d-none');
				this.getPrivacyPolicyCheckboxContainer().find('[name="marketingConsent"]').prop("checked", false);
				this.getPrivacyPolicyCheckboxContainer().removeClass('d-none');
			} else {
				this.getPrivacyPolicyAgreementMessageContainer().removeClass('d-none');
				this.getPrivacyPolicyCheckboxContainer().find('[name="marketingConsent"]').prop("checked", false);
				this.getPrivacyPolicyCheckboxContainer().addClass('d-none');
			}
		});
	}

	getRoot () {
		return $(`#${this.id}`);
	}

	getStepper () {
		return this.getRoot().find("[data-component=stepper]");
	}

	getStepperId () {
		return this.getStepper().attr("id");
	}

	getForm () {
		return this.getRoot().find("form");
	}

	getCountryField () {
		return this.getForm().find('[name="Country"]');
	}

	getPrivacyPolicyAgreementMessageContainer() {
		return this.getForm().find('[data-component="privacy-policy-agreement-message-container"]');
	}

	getPrivacyPolicyCheckboxContainer() {
		return this.getForm().find('[data-component="privacy-policy-checkbox-container"]');
	}

	getSubmitButton () {
		return this.getForm().find("button[type=submit]");
	}

	disableSubmitButton () {
		this.getSubmitButton().attr("disabled", "true");
	}

	serializeFormData () {
		return _.reduce(
			this.getForm().serializeArray(),
			(data, field) => _.set(data, field.name, field.value),
			{}
		);
	}

	async submit () {
		this.disableSubmitButton();

		this.stepper.nextStep();

		const data = this.serializeFormData();

		const kickboxResponse = await kickboxCheck(
			_.get(data, 'Email')
		);

		_.set(
			data,
			'Email_Verification_Status__c',
			kickboxResponse.result
		);

		_.set(
			data,
			'kickboxReason',
			kickboxResponse.reason
		);

		try {
			await FormController.marketo__submit(
				data,
				false,
				null,
				this.getForm()
			);
			dataLayer.push({ event: 'ajaxFormSubmitted' });
		} catch (e) {
			console.error(e);
		} finally {
			this.stepper.nextStep();
		}
	}
}

MultiSelectForm.init = (utmCookies) => {
	const objects = [];

	$('[data-component="multi-select-form"]').each((i, e) => {
		const id = $(e).attr("id");
		objects.push(new MultiSelectForm(id, utmCookies));
	});

	return objects;
}

module.exports = MultiSelectForm;
